/** Shared local coverage for footer + service landing pages */
export const localCoverage = {
  addressLine: '218 City Rd, London EC1V 2PN',
  streetAddress: '218 City Rd',
  locality: 'London',
  postalCode: 'EC1V 2PN',
  country: 'GB',
  phoneDisplay: '020 3336 7147',
  phoneTel: '+442033367147',
  neighborhoods: [
    'EC1V',
    'Old Street',
    'Angel',
    'Clerkenwell',
    'Islington',
    'Shoreditch',
    'Farringdon',
    'Hoxton',
    'Barbican',
    'Borough',
    'City of London',
  ],
  postcodes: ['EC1M', 'EC1R', 'EC1Y', 'N1', 'EC2A', 'SE1', 'E2', 'E8'],
}
